import { View, ScrollView, Image, Dimensions, Pressable, Text } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import { Row, Table } from 'react-native-table-component'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { useNavigation } from '@react-navigation/native'
import GlobalStyles from './../style';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'

let lang = undefined;
let typeSort = 0;

const Statistics = ({route}) => {
    const data = route.params != null ? JSON.parse(route.params) : null
    const screenWidth = Dimensions.get('window').width;

    const navigation = useNavigation();
    useLayoutEffect(() => {
      navigation.setOptions({
          //headerShown: false,
          headerTitle: transl('Roster.estadisticas', lang)
      })
    }, []);

    const forceUpdate = useForceUpdate();

  //receivedData
  const [value, setvalue] = useState('');
  const readValue = () => {
    AsyncStorage.getItem('equipos')
    .then((value)=> {
      setvalue(value)
      if(value !== undefined)displayRoster(value)
    })
  }
  readValue()

  lang = dr.idiomas[useSelector((state) => state.language)].value

  let state = { 
    tableHead: [
      returnPressable(transl('Statistics.pos', lang),0),
      returnPressable(transl('Statistics.nombre', lang),1),
      returnPressable(transl('Statistics.partidosJugados', lang),2),
      returnPressable(transl('Statistics.partidosGuardian', lang),3),
      returnPressable(transl('Statistics.partidosGolpeador', lang),4),
      returnPressable(transl('Statistics.partidosCazador', lang),5),
      returnPressable(transl('Statistics.partidosBuscador', lang),6),
      returnPressable(transl('Statistics.goles', lang),7),
      returnPressable(transl('Statistics.tiros', lang),8),
      returnPressable(transl('Statistics.rebotesD', lang),9),
      returnPressable(transl('Statistics.rebotesO', lang),10),
      returnPressable(transl('Statistics.regates', lang),11),
      returnPressable(transl('Statistics.faltas', lang),12),
      returnPressable(transl('Statistics.snitchs', lang),13),
      returnPressable(transl('Statistics.paradas', lang),14),
      returnPressable(transl('Statistics.golesEncajados', lang),15),
      returnPressable(transl('Statistics.asistencias', lang),16),
      returnPressable(transl('Statistics.balonesP', lang),17),
      returnPressable(transl('Statistics.balonesR', lang),18),
      returnPressable(transl('Statistics.bludgersL', lang),19),
      returnPressable(transl('Statistics.bludgersD', lang),20),
      returnPressable(transl('Statistics.edad', lang),21),
      returnPressable(transl('Statistics.semanasLesionado', lang),22)],
    widthArr: [30, 160, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80]
  }

  return (
    <View>
      <View>
        {/* <Button onPress={forceUpdate} title="force update"></Button> */}
        <ScrollView horizontal={true}>
          <View>
            <Table borderStyle={{borderWidth: 1, borderColor: '#C1C0B9'}}>
                <Row data={state.tableHead} widthArr={state.widthArr} style={styles.header} textStyle={styles.text}/>
            </Table>
            <ScrollView>
                <Table>
                  {
                    displayRoster(data,value)
                  }
                </Table>
            </ScrollView>
          </View>
        </ScrollView>
      </View>
    </View>
  )

  function displayRoster(data,value) {
    if(value === undefined || !value) {
      return <Image style={{width:screenWidth,height:screenWidth*0.6}} source={require('./../img/loading.gif')} />
    }
    if(typeof data != "object")data = data != null ? JSON.parse(data) : null
    //console.log(data.teams[0].players.length)
    
    const tableData = [];
    const myPlayers = data.teams[0].players;
    for (let i = 0; i < myPlayers.length; i += 1) {
      const rowData = [];
      rowData.push(i+1)

      rowData.push(myPlayers[i].name)
      rowData.push(myPlayers[i].stats.gAsKeeper + myPlayers[i].stats.gAsBeater + myPlayers[i].stats.gAsChaser + myPlayers[i].stats.gAsSeeker)
      rowData.push(myPlayers[i].stats.gAsKeeper)
      rowData.push(myPlayers[i].stats.gAsBeater)
      rowData.push(myPlayers[i].stats.gAsChaser)
      rowData.push(myPlayers[i].stats.gAsSeeker)
      rowData.push(myPlayers[i].stats.goals)
      rowData.push(myPlayers[i].stats.throws)
      rowData.push(myPlayers[i].stats.defensiveRebounds)
      rowData.push(myPlayers[i].stats.offensiveRebounds)
      rowData.push(myPlayers[i].stats.dribbles)
      rowData.push(myPlayers[i].stats.faults)
      rowData.push(myPlayers[i].stats.snitchs)
      rowData.push(myPlayers[i].stats.saves)
      rowData.push(myPlayers[i].stats.concededGoals)
      rowData.push(myPlayers[i].stats.assists)
      rowData.push(myPlayers[i].stats.bLost)
      rowData.push(myPlayers[i].stats.bStolen)
      rowData.push(myPlayers[i].stats.bludgersThrown)
      rowData.push(myPlayers[i].stats.bludgersSaves)
      rowData.push(myPlayers[i].age)
      rowData.push(myPlayers[i].injury)
      
      tableData.push(rowData);
    }

    sortData(typeSort,tableData);
  
    return tableData.map((rowData, index) => (
      <Row
        key={index}
        data={rowData}
        widthArr={state.widthArr}
        textStyle={{textAlign:'center'}}
        style={[
          !(index%2) && {backgroundColor: '#ffffff'},
          {paddingVertical:6}
        ]}
      />
    ))
  }

  function sortData(type,tableData) {
    tableData.sort(function(a, b) {
      if(type==0) return (a[0]) - (b[0])
      if(type==1) return (a[1].localeCompare(b[1]))
      else if(type==-1) return (b[1].localeCompare(a[1]))
      if(type > 0) return (b[type]) - (a[type]);
      else return (a[-type]) - (b[-type])
    });
  }

  function returnPressable(text,toSort) {
    return <Pressable
            style={GlobalStyles.buttonTable}
            onPress={() => {
                if(toSort == typeSort) typeSort = -typeSort
                else typeSort = toSort
                forceUpdate()
              }
            }>
            <Text style={GlobalStyles.textForButtonTable}>{text}</Text>
          </Pressable>
  }
}

function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => value + 1); // update state to force render
  // An function that increment 👆🏻 the previous state like here 
  // is better than directly setting `value + 1`
}



const styles = {
    container: { flex: 1, padding: 16, paddingTop: 30, backgroundColor: '#fff' },
    header: { height: 50, backgroundColor: '#e6e6e6' },
    text: { textAlign: 'center', fontWeight: 'bold', fontSize:13 },
    row: { height: 40, backgroundColor: '#E7E6E1' }
  };

export default Statistics